import React from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IElementLikertScale} from '../../../../../incase-domain/elements/question/likertScale';
import {LikertScaleInteractions} from '../../../../../incase-domain/proptypes/runfile';
import QuestionLayout from '../common/QuestionLayout';
import LikertScaleQuestions from './LikertScaleQuestions';
import useLikertScaleTry from './useLikertScaleTry';

interface LikertScaleQuestionElementProps {
    element: IElementLikertScale;
    elementInteractions: LikertScaleInteractions;
    savePresentationRunFile: (elementRunFile: Record<string, unknown>, newPoints?: number) => void;
    device?: DeviceType;
}

function LikertScaleQuestionElement(props: LikertScaleQuestionElementProps): JSX.Element {
    const {element, elementInteractions, savePresentationRunFile, device = DeviceType.DESKTOP} = props;

    const handleConfirm = useLikertScaleTry();

    const isConfirmDisabled = (): boolean => {
        if (elementInteractions.answered) {
            return true;
        }

        const answeredQuestions = elementInteractions.likertScaleAnswerClicked || [];
        return answeredQuestions.length < element.questions.length;
    };

    return (
        <QuestionLayout
            element={element}
            hostStyled={Boolean(element.htmlSlotId)}
            elementInteractions={elementInteractions}
            device={device}
            showConfirmButton
            onConfirm={() => handleConfirm(element, elementInteractions)}
            confirmDisabled={isConfirmDisabled()}
        >
            <LikertScaleQuestions
                device={device}
                element={element}
                elementInteractions={elementInteractions}
                savePresentationRunFile={savePresentationRunFile}
            />
        </QuestionLayout>
    );
}

export default LikertScaleQuestionElement;
